module.exports = __webpack_public_path__ + "static/venice20891-5edf46b963e8cd6f696962e201e68f12.webp";